// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@awc/App/Widgets/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@awc/App/Widgets/GoogleAnalyticsConnector/Utilities/DataLayer";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain, DispatchCompleteSendRmaRequest } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";

export const _GaSendTracking: typeof DispatchCompleteSendRmaRequest = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    if (state.xGoogleAnalytics.returnRequestEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const orderState = getOrderState(state, props.parameter.orderNumber);

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.returnRequestEventName,
            affiliation: state.xGoogleAnalytics.affiliation,
            items: [] as any,
        };

        props.apiParameter.rmaModel.rmaLines?.forEach((product, idx) => {
            const orderline = orderState.value?.orderLines?.find(ol => ol.lineNumber === product.line);
            googleAnalyticsData.items.push({
                item_name: orderline?.description,
                item_id: orderline?.productErpNumber,
                quantity: product.rmaQtyRequested,
                return_reason: product.rmaReasonCode,
            });
        });

        dataLayer.push(googleAnalyticsData);
    }
};

addToEndOfChain(chain, _GaSendTracking);